import * as v from 'valibot';

import { newSchema } from '../../../utils/valibot/schema';

export const ImageUrlResultSchema = newSchema(
  'ImageUrlResultSchema',
  v.object({
    imageUrl: v.string(),
  }),
);

export type ImageUrlResult = v.InferOutput<typeof ImageUrlResultSchema>;
